module.exports = __webpack_public_path__ + "static/media/mode-23.cfac370e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-23.svg
// module id = 996
// module chunks = 2